import { Link } from "react-router-dom";

import img from "../assets/dionisiache_home.jpg";

import classes from "./css/DionisiacheHome.module.css";

const DionisiacheHome = () => {
  return (
    <div className={classes.main}>
      <div className={classes.row_dionisiache}>
        <div className={classes.info_container}>
          <div className={classes.info_dionisiache}>
            <h1>DIONISIACHE</h1>
            <h2>Teatro Festival</h2>
            <h5>
              Dionisiache Teatro Festival è un progetto culturale
              che nasce dalla “necessità” di raccontare i Miti: storie e
              racconti legati ai momenti fondamentali della vita degli uomini e
              alle loro emozioni trasversalmente ad ogni periodo storico. Nel
              mito rientrano tutte le strutture narrative, dalla drammaturgia
              classica alla drammaturgia contemporanea, da Eschilo a Pirandello
              fino ad arrivare ad una “visione” multimediale della
              rappresentazione scenica
            </h5>
            <Link to="/dionisiache">Scopri di più</Link>
          </div>
        </div>

        <div className={classes.image_container}>
          <img src={img} alt="dionisiache" className={classes.image} />
        </div>
      </div>
    </div>
  );
};

export default DionisiacheHome;
